import { render, staticRenderFns } from "./SelectParent.vue?vue&type=template&id=898c9776&scoped=true&"
import script from "./SelectParent.vue?vue&type=script&lang=js&"
export * from "./SelectParent.vue?vue&type=script&lang=js&"
import style0 from "./SelectParent.vue?vue&type=style&index=0&id=898c9776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898c9776",
  null
  
)

export default component.exports